import { useEffect, useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  DateField,
  BooleanField,
  NumberField,
  // useTranslate,
  useTheme,
  usePermissions,
} from "react-admin";
import allTransactionJournalFilterList from "../../components/allTransactionJournals/filter/allTransactionJournalFilterList";
import AllTransactionJournalExpandList from "../../components/allTransactionJournals/expand/AllTransactionJournalExpandList";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import ManualReportList from "../../components/reports/ManualReportList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const ExpandAll = () => {
  useEffect(() => {
    const expandAllBtn = document.querySelector(
      "table.RaDatagrid-table .RaDatagrid-thead .RaDatagrid-headerRow .RaDatagrid-expandHeader .RaDatagrid-expandIcon:not(.RaDatagrid-expanded)"
    );
    if (expandAllBtn) {
      var clickEvent = new MouseEvent("click", {
        view: window,
        bubbles: true,
        cancelable: false,
      });
      expandAllBtn.dispatchEvent(clickEvent);
    }
  }, []);
  return null;
};

const AllTransactionJournalList = () => {
  // const t = useTranslate();
  const [theme] = useTheme("light");
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
      is_balance: true,
    });

  const list = useMemo(
    () => (
      <ManualReportList
        title="mine.list_title.all_transaction_journal"
        empty={false}
        actions={<DownloadAction />}
        filters={allTransactionJournalFilterList(permissions, { includeCompany: false })}
        sort={{ field: "code", order: "ASC" }}
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
        // queryOptions={{ meta: { sort: ["transactions.code ASC"] } }} // overide default sort
      >
        <DatagridConfigurable
          bulkActionButtons={false}
          expand={<AllTransactionJournalExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          <ExpandAll />
          {canSeeCompanyColumn ? (
            <TextField source="company.alias" label="mine.label.depo" />
          ) : null}
          <TextField source="code" label="mine.label.receipt_no" />
          <DateField
            source="date"
            label="mine.label.date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <TextField source="cus_sup" label="mine.label.cus_sup" />
          <NumberField source="total_debit" />
          <NumberField source="total_credit" />
          <BooleanField
            source="is_balance"
            label="mine.label.balance"
            textAlign="center"
          />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return list;
};

export default AllTransactionJournalList;
